import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isLoggedIn()) {
    const roles = route.data['roles'] as string[];
    if (roles && !auth.hasRoles(roles)) {      
      return router.createUrlTree(['/not-found']);
    }
    return true;
  } else {
    // Optional: you can pass the attempted URL for redirect after login
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }  
};
